import { ApiService } from '../../../services/api_service';
import { Data } from './DataConfig';
import { DataService } from '../../../services/data_service';
import { ImportRoutine } from '../ImportRoutine';
import { lazyInject } from '../../../services/inversify';
import { StructureService } from '../../../services/structure_service';
import * as React from 'react';
import { renderProgressBar } from '../../elements/formula/WProgressBar';
import style from '../import_tool.less';
import { WFormsTableWrapper } from '../../table/WFormsTableWrapper';
import { WSpinner } from '../../../core/elements/spinner/WSpinner';

interface ImportProcDataCheckProps extends React.ClassAttributes<any> {
    data: any;
    modul: string;
    IDs: any;
    onLockChange: (locked: boolean) => void;
    onDataChange: (data: any) => void;
    onDone: () => void;
    simple?: boolean;
}

export class ImportProcDataCheckState {
    targetData: Array<any>;
    processedData?: Array<any>;
    saveData?: Array<any>;
    delData?: Array<any>;
    bundle?: any;
    disabledSaveButton: boolean;
    rowWithFehler?: Array<any>;
    selectedOption?: number;
    filteredData?: any;
    deleteLeftovers: boolean;
    forLegend?: Array<any>;
    importProgress: number;
    isDeleting: boolean;
    isBackuping: boolean;
}

export class ImportProcDataCheck extends React.Component<ImportProcDataCheckProps, ImportProcDataCheckState> {

    constructor(props: any) {
        super(props);
        this.onButtonPress = this.onButtonPress.bind(this);
        this.onDataProcessed = this.onDataProcessed.bind(this);
        this.onLoadedBundle = this.onLoadedBundle.bind(this);
        this.onAfterPreprocess = this.onAfterPreprocess.bind(this);
        this.saveListPart = this.saveListPart.bind(this);
        this.saveBackup = this.saveBackup.bind(this);
        this.backupAndSave = this.backupAndSave.bind(this);
        this.done = this.done.bind(this);
        this.state = {
            targetData: undefined,
            disabledSaveButton: false,
            deleteLeftovers: false, // Fehlende Datensätze löschen
            importProgress: undefined,
            isDeleting: false,
            isBackuping: false
        };
    }

    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(StructureService) private structureService: StructureService;
    @lazyInject(ImportRoutine) private importRoutine: ImportRoutine;
    @lazyInject(ApiService) private apiService: ApiService;

    private saveIndex = 0;
    private maxPartJob = 5;
    private numPartJob = 0;

    componentDidMount() {
        this.setState({
            targetData: this.updateData(this.importRoutine.process(this.props.data, this.props.modul, this.props.data.ignoreRows))
        });
        this.dataService.loadDataForModul(this.props.data.structureKey, { tid: -1 }, { bundle: 1 }, this.props.modul, this.onLoadedBundle);
    }

    onLoadedBundle(data: any) {
        console.log('got bundle:', data);
        // alert('got bundle');
        if (data.bundle) {
            this.setState({ bundle: data.bundle });
        } else {
            this.setState({ bundle: {} }); // Es muss gesetzt werden, wenn auch leer
        }
    }

    updateData(data: Array<any>) {
        const fallback: any = Data.fallback[this.props.data.structureKey || null] || {};
        const predefined: any = Data.predefined[this.props.data.structureKey || null] || {};
        const values: any = this.props.data.selectedValues || {};
        const whitelist: any = Data.whitelist[this.props.data.structureKey || null] || {};
        const fields: any = { ...predefined, ...values };
        return (Object.keys(fields).length || Object.keys(fallback).length || Object.keys(whitelist).length)
            ? (data || []).map((row: any) => {
                Object.keys(whitelist).forEach((field: string) => {
                    if (Array.isArray(whitelist[field]) && typeof row[field] !== 'undefined') {
                        row[field] = whitelist[field].indexOf(row[field]) !== -1 ? row[field] : '';
                    }
                });
                Object.keys(fallback).forEach((field: string) => {
                    if (
                        typeof fallback[field] !== 'undefined'
                        && (typeof row[field] === 'undefined' || row[field] === null || !row[field].toString().trim().length)
                    ) {
                        row[field] = fallback[field];
                    }
                });
                Object.keys(fields).forEach((field: string) => {
                    if (typeof fields[field] !== 'undefined') {
                        row[field] = fields[field];
                    }
                });
                return row;
            })
            : data;
    }

    render() {
        const structureKey = this.props.data.structureKey;

        if (this.state.importProgress !== undefined) {
            return <div> Import-Fortschritt ({<i> {'Fenster bitte nicht schließen'} </i>}):
                {renderProgressBar(400, this.state.importProgress)}</div>;
        }
        if (!this.state.targetData) {
            return (
                <div>Verarbeite Daten ...</div>);
        }
        // console.log('TargetData: ', this.state.targetData);
        // console.log('FilterData:', this.state.filteredData);
        return (
            <div>
                <div>
                    {this.state.saveData && `Anzahl zu speichernder Datensätze: ${this.state.saveData.length}`}
                    <span className={style.alert}>
                        {this.state.rowWithFehler &&
                        ` Anzahl der Datensätze mit Problem: ${this.state.rowWithFehler.length}`}
                    </span>
                </div>
                <div>
                    {this.state.saveData ?
                        <input
                            className={style.normal}
                            style={{
                                padding: 10, backgroundColor: this.state.saveData.length > 0 ? '#afa' : '#faa', border: '2px solid #0a0',
                                borderRadius: 5, color: '#080', fontWeight: 'bold', width: 420
                            }}
                            type='button'
                            value='Daten jetzt importieren'
                            disabled={this.state.disabledSaveButton || this.state.isDeleting}
                            onClick={this.onButtonPress}
                        />
                        :
                        <div
                            style={{ backgroundColor: '#ffa', width: 200, padding: 10 }}
                        >
                            <i>Prüfe Datensätze ...</i>
                            <WSpinner label='Prüfe' />
                        </div>
                    }
                    {this.state.isDeleting && <WSpinner label='Lösche' />}
                    {this.state.isBackuping && <WSpinner label='Backup' />}
                </div>
                {this.props.simple && this.state.filteredData &&
                    <WFormsTableWrapper
                        module={this.props.modul}
                        entity={structureKey}
                        data={this.state.filteredData}
                        diffData={this.state.targetData}
                        customClass={'Custom-ETA'}
                        formLayout={'flowV2'}
                        actions={[]}
                        showLegend={true}
                        delMissing={true}
                        dropFilter={true}
                        onDeleteLeftoversChange={(deleteLeftovers: boolean) => this.setState({ deleteLeftovers })}
                        disableGlobalFilter={true}
                    />
                }
                {!this.state.filteredData &&
                    <div style={this.props.simple ? { maxWidth: 0, maxHeight: 0, overflow: 'hidden' } : {}}>
                        <WFormsTableWrapper
                            module={this.props.modul}
                            entity={structureKey}
                            diffData={this.state.targetData}
                            onDiffDataProcessed={this.onDataProcessed}
                            customClass={'Custom-ETA'}
                            formLayout={'flowV2'}
                            actions={[]}
                            showLegend={true}
                            delMissing={true}
                            dropFilter={true}
                            onDeleteLeftoversChange={(deleteLeftovers: boolean) => this.setState({ deleteLeftovers })}
                            disableGlobalFilter={true}
                        />
                    </div>
                }
            </div>
        );
    }

    onDataProcessed(data: Array<any>, type: boolean) {
        const processedData = data;
        const delData: Array<any> = [];
        const saveData: Array<any> = [];
        (data || []).forEach((row: any) => {
            const item: any = { ...row };
            if (row.internal._diffState === 2) { // neu {2}
                Object.keys(row).forEach((field: string) => {
                    if (typeof row[field] === 'string' && !row[field].length) {
                        delete item[field]; // entferne leere Zelle
                    }
                    if (typeof row[field] === 'string' && row[field] === 'undefined') {
                        delete item[field]; // entferne Zelle mit "undefined"
                    }
                });
            }
            if (
                (this.props.simple && !this.props.data.tid && row.internal._diffState === 2)
                || (!this.props.simple && (row.internal._diffState === 1 || row.internal._diffState === 2))
            ) {
                saveData.push(item);
            }
            if (!this.props.simple && row.internal._diffState === 3) {
                delData.push(item);
            }
        });
        // const saveData = this.props.simple && !this.props.data.tid
        //     ? data.filter((row: any) => row.internal._diffState === 2) // neu {2}
        //     : data.filter((row: any) => row.internal._diffState === 1 || row.internal._diffState === 2);
        // const delData = this.props.simple && !this.props.data.tid
        //     ? []
        //     : data.filter((row: any) => row.internal._diffState === 3);
        if (type) {
            if (processedData.length > 0) {
                this.setState({ rowWithFehler: processedData });
            }
        }
        this.setState({ processedData, saveData, delData }, () => {
            this.state.processedData.length === 0
                ? this.setState({ disabledSaveButton: true })
                : this.setState({ disabledSaveButton: false }, () => {
                    if (this.props.simple && !this.props.data.tid && !type) {
                        this.onButtonPress({});
                    }
                });
        });
    }

    onButtonPress(e: any) {
        if (this.state.saveData.length === 0) {
            if (this.state.deleteLeftovers) {
                alert('Es wurden keine neuen oder geänderten Datensätze gefunden! Überflüssige Datensätze werden nun entfernt!');
            } else {
                alert('Es wurden keine neuen oder geänderten Datensätze gefunden! Der Import kann nicht durchgeführt werden.');
                return;
            }
        }
        this.preprocess(this.state.saveData, this.state.delData, this.onAfterPreprocess);
    }

    onAfterPreprocess(saveData: Array<any>, delData: Array<any>) {
        // Bereinigen ---> Internal entfernen *****************************
        saveData.forEach((d) => delete (d.internal));
        saveData.forEach((d) => {
            const fieldKeys = Object.keys(d);
            // console.log(fieldKeys);
            fieldKeys.forEach((k: string) => {
                const idx_orig: number = k.indexOf('_orig');
                if (idx_orig > -1) {
                    const orig_key = k.substr(0, idx_orig);
                    if (d[orig_key]) { // Das Feld mit "_orig" nur entfernen, wenn es auch das Original gibt
                        delete (d[k]);
                    }
                }
            });
        });
        // Bereinigen ENDE ***********************************
        // Erst löschen, dann speichern
        const useDelData = this.state.deleteLeftovers ? delData : undefined;
        this.setState({ isDeleting: true }, () => {
            this.dataService.delDataList(this.props.data.structureKey, useDelData, () => {
                if (saveData.length === 0) {
                    this.setState({ isDeleting: false }, () => {
                        const data = this.props.data;
                        data.newData = 0;
                        this.props.onDataChange(data);
                        this.props.onDone();
                    });
                } else {
                    this.setState({ isDeleting: false }, () => {
                        this.props.onLockChange(true);
                        this.setState({ importProgress: 0 }, () => this.backupAndSave(saveData));
                    });
                }
            });
        });
    }

    backupAndSave(saveData: Array<any>) {
        this.saveListPart(saveData, () => {
            this.setState({ isBackuping: true }, () => {
                this.saveBackup(() => {
                    this.setState({ isBackuping: false }, () => {
                        this.done();
                    });
                });
            });
        });
    }

    saveListPart(saveData: Array<any>, callback: () => void) {
        const that = this;
        // Start parallel job
        while (saveData.length > 0 && this.numPartJob < this.maxPartJob) {
            const saveRange = this.getSaveRange(saveData, this.saveIndex);
            const len = saveData.length;
            let endIndex = this.saveIndex + saveRange;
            if (endIndex > len) {
                endIndex = len;
            }
            const saveDataPart = saveData.slice(this.saveIndex, endIndex);
            if (saveDataPart && saveDataPart.length > 0) {
                console.log('Import : SaveListPart: Start ' + this.saveIndex + ' Items: ' + saveDataPart.length);
                this.numPartJob++;
                this.dataService.saveDataList(this.props.data.structureKey, saveDataPart, (json: string, suc: boolean) => {
                    // Parse Result
                    let obj;
                    try {
                        obj = JSON.parse(json);
                    } catch (e) { }
                    console.log(this.props.data.structureKey, obj, suc);
                    // Set Progress
                    const importProgress = Math.round(100 / len * this.saveIndex);
                    this.setState({ importProgress });
                    // Start the next job or finished
                    this.numPartJob--;
                    if (this.saveIndex < len - 1) {
                        that.saveListPart(saveData, callback);
                    } else if (this.numPartJob === 0) {
                        const data = this.props.data;
                        data.newData = saveData.length;
                        this.props.onDataChange(data);
                        callback();
                    }
                }, this.props.modul);
                this.saveIndex = endIndex;
            } else {
                break;
            }
        }
    }
    // Diese Funktion berechnet dynamisch die max. Anzahl der Datensätze per POST zu schicken.
    getSaveRange(data: Array<any>, idxFrom: number, maxInputVars = 1000) {
        maxInputVars -= 50; // 50 Plätze für dataService Parameter reserviert
        let range = 0;
        const length = data.length;
        if (idxFrom <= length && maxInputVars > 0) {
            let sum = 0;
            for (let i = idxFrom; i <= length; i++) {
                let rowLen = 1;
                if (typeof data[i] === 'object') {
                    rowLen = Object.keys(data[i]).length;
                }
                if (sum + rowLen <= maxInputVars) {
                    sum += rowLen;
                    range++;
                } else {
                    break;
                }
            }
        }
        return range;
    }

    saveBackup(callback: () => void) {
        const backupDataSave = this.props.data;
        delete (backupDataSave.sheetDataAll);
        console.log('Import (' + new Date() + ') : saveBackup ... ');
        this.dataService.saveBackupForModul(this.props.data.structureKey, this.props.IDs.MOD_CORE,
            this.props.data.titel, this.props.IDs.ENT_BACKUP_INFO, backupDataSave,
            (backupData: any, suc: boolean) => {
                this.writeImportLog(backupData, callback);
            });
    }

    writeImportLog(backupData: any, callback: () => void) {
        console.log('Import (' + new Date() + ') : writeImportLog ... ');
        const user = this.apiService.getUsername();
        const backupDataForImport = JSON.parse(backupData);
        const logWrite = {
            definition: this.props.data.titel,
            schnittstellen: this.props.data.structureKey,
            user: user ? user : '',
            aktion: 'Datensätze importiert',
            stamp: Date.now(),
            backup_id: parseInt(backupDataForImport.backupTid, 10)
        };
        this.dataService.saveData(this.props.IDs.ENT_IMPORT_LOG, logWrite, null, null, () => {
            // Hier jetzt done ...
            callback();
        }, this.props.modul);
    }

    done() {
        console.log('Import (' + new Date() + ') : done ... ');
        this.props.onLockChange(false);
        this.props.onDone();
    }

    preprocess(data: Array<any>, delData: Array<any>, onAfterPreprocess: (saveData: Array<any>,
        delData: Array<any>) => void, secondRun?: boolean) {
        const dataBackup = JSON.stringify(data); // Original-Daten für einen möglichen 2. Durchlauf merken
        let hasFatalError = false;
        const structure = this.structureService.getStructureByKey(this.props.modul, this.props.data.structureKey);
        // console.log('IMP S', structure);
        const refAdds: any = {};
        const fallback: any = Data.fallback[this.props.data.structureKey || null] || {};
        const predefined: any = Data.predefined[this.props.data.structureKey || null] || {};
        // Wir dürfen nur die Spalten im Mapping verarbeiten !!!
        const selectedFields = this.props.data.selectedFields;
        // console.log('Import SelFields:', selectedFields);
        // alert('check');
        console.log('Structure: ', structure);
        const saveData = data.map((item: any) => {
            structure.ATTS.forEach((att: any) => {
                if (hasFatalError) {
                    return; // nicht weiter machen
                }
                if (
                    !Object.keys(selectedFields).find((k: string) => selectedFields[k] === att.KEY)
                    && Object.keys(fallback).indexOf(att.KEY) === -1 && Object.keys(predefined).indexOf(att.KEY) === -1
                ) {
                    // console.log('No Transform : ' + att.KEY);
                    return;
                }
                console.log('ATT: ', att);
                if (att.OPTS && att.OPTS instanceof Object) {
                    const refEntity = att.OPTS.ENTITY;
                    const refId = att.OPTS.IDENTIFIER;
                    const refInput = att.OPTS.INPUT;
                    const field = att.KEY;
                    const value = item[field];
                    const refResult = this.resolveReference(field, refEntity, refId, refInput, value);
                    console.log('Ref? ', refResult, field, refEntity, refId, refInput, value);
                    if (refResult === -999) {
                        if (Array.isArray(att.OPTS)) {
                            item[field] = this.resolveReferenceByValues(field, att.OPTS, value);
                        }
                        // hasFatalError = true;
                    } else if (value !== undefined && value !== null) {
                        if (false && refResult === -1) { // automatische Eintragung neuer Werte in Referenztabelle erstmal deaktiviert
                            console.log('Neue Ref: ', field, refEntity, refId, refInput, value);
                            // Neuer Wert
                            if (!refAdds[refEntity]) {
                                refAdds[refEntity] = [];
                            }
                            const addField: any = {};
                            addField.tid = 0;
                            addField[refInput] = value;
                            if (!refAdds[refEntity].find((check: any) => check[refInput] === value)) { // Keine Doubletten!
                                refAdds[refEntity].push(addField);
                            }
                        } else {
                            // Alles klar
                            item[field] = refResult;
                        }
                    } else {
                        item[field] = undefined;
                    }
                }
            });
            return item;

        });
        console.log('RefAdds: ', refAdds);
        // Jetzt für jede gefundene RefAdd
        if (hasFatalError) {
            // alert(' Fataler Fehler !');
        }
        const refAddKeys = Object.keys(refAdds);
        if (refAddKeys.length === 0 || secondRun) {
            onAfterPreprocess(saveData, delData);
        } else {
            let done = 0;
            const originalData = JSON.parse(dataBackup); // Original-Daten für den 2. Durchlauf zurückholen
            refAddKeys.forEach((key: string) => {
                console.log('Speichere Referenzen für ' + key, refAdds[key]);
                //  alert('check');
                this.dataService.saveDataList(key, refAdds[key], (d: string, b: boolean) => {
                    done++;
                    console.log('Speichere Referenzen für ' + key + ' Erledigt !');
                    if (done === refAddKeys.length) {
                        // Nochmal bundle neu laden
                        this.dataService.loadDataForModul(this.props.data.structureKey, { tid: -1 }, { bundle: 1 },
                            this.props.modul, (reloadedData: any) => {
                                if (reloadedData.bundle) {
                                    this.setState({ bundle: reloadedData.bundle },
                                        () => this.preprocess(originalData, delData, onAfterPreprocess, true));
                                } else {
                                    this.setState({ bundle: {} }, () => this.preprocess(originalData, delData, onAfterPreprocess, true));
                                }
                            });
                    }
                }, this.props.modul);
            });
        }
    }

    resolveReference(field: string, refEntity: string, refId: string, refInput: string, value: string) {
        if (value === undefined) { // Gar nicht erst prüfen
            return -1;
        }
        // console.log('Resolve Ref: ' + refEntity + ' , ' + refId + ' , ' + refInput + ' ---> ' + value);
        if (!this.state.bundle || !this.state.bundle[field]) {
            console.log('Resolve Ref: (' + field + ') No bundle ...', this.state.bundle);
            // alert('Datenstruktur unvollständig!');
            return -999;
        }
        if (value === undefined) {
            return 0;
        }
        const bundleData = this.state.bundle[field];
        // console.log('Resolf Ref:  (' + field + ') found!');
        // 1. Schritt, wir versuchen den Wert direkt zu finden
        const valFound = bundleData.find((item: any) => item[refInput] === value);
        if (valFound) {
            return valFound[refId];
        }
        // 2. Schritt wir versuchen einen Wert zu finden der sich mit unserem Überschneidet
        const valFound2 = bundleData.find((item: any) => item[refInput].toLowerCase().indexOf(value.toLowerCase()) > -1 ||
                                                         value.toLowerCase().indexOf(item[refInput].toLowerCase()) > -1);
        if (valFound2) {
            return valFound2[refId];
        }
        return -1;
    }

    resolveReferenceByValues(field: string, refValues: Array<any>, value: number | string) {
        const ref: any = (refValues || [])
            .find((item: any) => typeof item.VALUE !== 'undefined' && (item.TITEL || null) === value) || {};
        return typeof ref.VALUE !== 'undefined' ? ref.VALUE : '';
    }
}
